import { PaymentMethod } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const paymentsProvidersGet = (): Promise<PaymentMethod[]> => {
    const { Payments } = request();
    return Payments.paymentsProvidersGet().then((resp) => resp.data);
};
